/**
 * Utility functions related to the progress bar component
 */

import type { ValidAnchorOptions } from '../types/progress';

/**
 * Checks if an anchor element is valid for triggering the progress bar.
 * @param element - The anchor element to check
 * @returns Whether the anchor element is valid for triggering the progress bar
 */
export function isValidAnchor(element: HTMLAnchorElement): boolean {
  if (!element) return false;

  const href = element.getAttribute('href')?.trim() ?? '';
  const target = element.getAttribute('target');
  const rel = element.getAttribute('rel');

  return (
    href.startsWith('/') &&
    target !== '_blank' &&
    (!rel || !['noopener', 'noreferrer'].some((v) => rel.includes(v)))
  );
}

/**
 * Extracts the necessary attributes from an anchor element for validation.
 * @param element - The anchor element to extract attributes from
 * @returns The extracted attributes
 */
export function getAnchorOptions(element: HTMLAnchorElement): ValidAnchorOptions {
  return {
    href: element.getAttribute('href')?.trim() ?? '',
    target: element.getAttribute('target'),
    rel: element.getAttribute('rel'),
  };
}
